import Vue from 'vue'
import PageLoading from '~/components/common/Loading/PageLoading'

Vue.component('page-loading', PageLoading)
